import { Product } from '@planone/bau365/util-fair-data';

export const staticProducts: { [id: string]: Product } = {
  'AOC 60 TI': {
    id: 'AOC 60 TI',
    exhibitor_id: 'schueco',
    name: 'AOC 60 TI',
    description:
      'Aufsatzkonstruktion auf Holz für Fassade und Lichtdach mit exzellenten Leistungseigenschaften Patentierte Systemkomponenten ermöglichen selbst bei großen Scheibendimensionen eine einfache und sichere Ausführung inklusive Lastabtragung und Schraubenführung – auch bei Dreifachverglasungen. Im Dachbereich sorgt das innovative Abdichtungssystem durch integrierte Schraubenführung für maximale Wärmedämmung. Die Aufsatzkonstruktion auf Holz vereint energieeffizientes, ästhetisch anspruchsvolles Bauen mit rationeller Fertigung und Montage.',
    product_groups: [
      {
        id: '02.01',
        external_id: '',
        name: 'Fassade',
        root_path: ['02.01'],
      },
    ],
    topics: [
      {
        id: 'sustainable',
        name: 'Sustainable',
        description: 'Sustainable',
      },
    ],
    images: [
      {
        description: 'Plan.One',
        resource:
          'https://files.api.plan.one/v1/images/52e86106-78f3-40fa-ac2f-2e3c0c286ac3?quality=80&background=white&mode=PAD&width=438&height=438',
        provider: 'RAW',
      },
    ],
    key_facts: ['Witterungsbeständig'],
    countries: ['Deutschland', 'Schweiz', 'Östereich'],
    downloads: [
      {
        name: 'Die neue Dimension des Wohnens mit Aluminium-Fenstersystemen',
        file_name: 'Aluminium-Fenstersystemen',
        size: <string>(<unknown>204800), // kann ignoriert werden
        path: 'https://www.schueco.com/resource/blob/8044/8703ffacc4ca3d22705b83fa5d46ba73/aluminium_fenster_systeme_p4035.pdf?domain=de',
      },
      {
        name: 'Schüco Living Classic',
        file_name: 'Schüco Living Classic',
        size: <string>(<unknown>204800), // kann ignoriert werden
        path: 'https://www.schueco.com/resource/blob/8046/d8c498415a5640cd526db2429652435d/schueco_livlng_classic_P4151.pdf?domain=de',
      },
      {
        name: 'Schüco Livlng Rondo',
        file_name: 'Schüco Livlng Rondo',
        size: <string>(<unknown>204800), // kann ignoriert werden
        path: 'https://www.schueco.com/resource/blob/8048/68b37e12213c9d37f8e09565e16a5caf/schueco_livlng_rondo_P4411.pdf?domain=de',
      },
      {
        size: <string>(<unknown>204800), // kann ignoriert werden
        path: 'https://www.schueco.com/resource/blob/8048/68b37e12213c9d37f8e09565e16a5caf/schueco_livlng_rondo_P4411.pdf?domain=de',
      },
    ],
    videos: [
      {
        provider: 'YOUTUBE',
        resource: 'Bb7L3wBH3so',
      },
      {
        provider: 'YOUTUBE',
        resource: 'dYrMRd4DSkU',
      },
      {
        provider: 'YOUTUBE',
        resource: 'zXq_SL-wsrQ',
      },
    ],
    links: [
      {
        text: 'Plan.One',
        path: 'https://plan.one',
      },
      {
        text: 'Schüco',
        path: 'https://schueco.de',
      },
    ],
    contact_persons: [
      {
        id: '1',
        title: '',
        first_name: 'Ihr',
        name: 'Ansprechpartner',
        job_title: 'Kundenbetreuung',
        email: 'irgendwas@plan.one',
        phone: '08773 18-78889256',
        mobile: '',
        avatar: {
          description: '',
          resource: 'assets/mock-exhibitor-page/contactPersonIMG.webp',
          provider: 'RAW',
        },
      },
      {
        id: '2',
        title: '',
        first_name: 'Ihr',
        name: 'Ansprechpartner',
        job_title: 'Kundenbetreuung',
        email: 'irgendwas@plan.one',
        phone: '08773 18-78889256',
      },
      {
        id: '3',
        title: '',
        first_name: 'Ihr',
        name: 'Ansprechpartner',
        job_title: 'Kundenbetreuung',
        email: 'irgendwas@plan.one',
        phone: '08773 18-78889256',
      },
      {
        id: '4',
        title: '',
        first_name: 'Ihr',
        name: 'Ansprechpartner',
        job_title: 'Kundenbetreuung',
        email: 'irgendwas@plan.one',
        phone: '08773 18-78889256',
        mobile: '',
        avatar: {
          description: '',
          resource: 'assets/mock-exhibitor-page/contactPersonIMG.webp',
          provider: 'RAW',
        },
      },
    ],
  },
};
